import { render, staticRenderFns } from "./ProgramListPage.vue?vue&type=template&id=b999e7e8&scoped=true"
import script from "./ProgramListPage.ts?vue&type=script&lang=js&external"
export * from "./ProgramListPage.ts?vue&type=script&lang=js&external"
import style0 from "./../../../pages/filterlist.scss?vue&type=style&index=0&id=b999e7e8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b999e7e8",
  null
  
)

export default component.exports